<template>
  <context-menu
    v-model:show="showModel"
    :options="options"
    @update:show="onUpdateShow"
  >
    <context-menu-item
      v-for="(item, index) in items"
      :key="index"
      :label="item.label"
      @click="() => onItemClick(item)"
    />
  </context-menu>
</template>

<script>
import { computed } from "vue";
import { ContextMenu, ContextMenuItem } from "@imengyu/vue3-context-menu";

export default {
  name: "CalendarContextMenu",

  components: {
    ContextMenu,
    ContextMenuItem,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({
        x: 0,
        y: 0,
        zIndex: 1000,
        minWidth: 200,
        customClass: "calendar-context-menu",
        theme: "default",
      }),
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["update:show", "itemSelected"],

  setup(props, { emit }) {
    // Two-way binding for show property
    const showModel = computed({
      get: () => props.show,
      set: (value) => emit("update:show", value),
    });

    // Handle show state update
    const onUpdateShow = (value) => {
      emit("update:show", value);
    };

    // Handle menu item click
    const onItemClick = (item) => {
      emit("itemSelected", item);
    };

    return {
      showModel,
      onUpdateShow,
      onItemClick,
    };
  },
};
</script>

<style scoped>
/* Custom context menu styles to ensure visibility */
:deep(.mx-context-menu) {
  background-color: #ffffff !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2) !important;
  border: 1px solid #ced4da !important;
}

:deep(.mx-context-menu-item) {
  padding: 8px 16px !important;
  cursor: pointer !important;
  color: #333 !important;
}

:deep(.mx-context-menu-item:hover) {
  background-color: #f0f7ff !important;
}
</style>
